module.exports = new __parcel__URL__("Proj Status Report.972dc052.svg").toString();